import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Van stock orders, office side. The FSM screens only ever show an engineer his
// own orders, or the storeroom its open picking queue — this is every order,
// with what was asked for against what was picked.

export function useVanOrders(filters = {}) {
  const qs = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => { if (v) qs.set(k, v); });
  const query = qs.toString();
  return useQuery({
    queryKey: ['vanOrders', 'list', query],
    queryFn: async () => (await api.get(`/api/van-requests/storeroom/all${query ? `?${query}` : ''}`)).data,
    staleTime: 0,
  });
}

export function useVanOrder(id) {
  return useQuery({
    queryKey: ['vanOrders', 'detail', String(id)],
    queryFn: async () => (await api.get(`/api/van-requests/${id}`)).data,
    enabled: !!id,
    staleTime: 0,
  });
}

export function useVanOrderStorerooms() {
  return useQuery({
    queryKey: ['vanOrders', 'storerooms'],
    queryFn: async () => (await api.get('/api/stock-orders/storerooms')).data.storerooms,
    staleTime: 300000,
  });
}
